import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import SignUpModal from './SignUpModal';

const ComposedSignUpModal = compose(
  withRouter,
  injectIntl
)(SignUpModal);
ComposedSignUpModal.display = SignUpModal.displayName;

export default ComposedSignUpModal;
